import {
  Box,
  Grid,
  TextField,
  Typography,
  InputLabel,
  Stack,
  Checkbox,
  Button,
  Link,
  FormControl,
  Select,
  MenuItem,
} from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { format } from "date-fns";

import "dayjs/locale/de";

import React, { useState, useEffect } from "react";
import { useAuth } from "../../contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import { useAddReservationMutation } from "../../app/services/reservationApi";
import { useSelector } from "react-redux";
import Login from "../admin/authentification/Login";
import Conditions from "./Conditions";
import Loader from "../loader/Loader";
import Bureau from "./Bureau";

function ClientAuth() {
  const navigate = useNavigate();
  const state = useSelector((state) => state.change.value);
  const stateRetrait = useSelector((state) => state.reservation.value);
  const [addReservation, { data: reservation1, isLoading, isError, error }] =
    useAddReservationMutation();
  const { user } = useAuth();
  const [isChecked, setIsChecked] = useState(false);
  const [isButtonEnabled, setIsButtonEnabled] = useState(false);
  const [loading, setLoading] = useState(false);

  const dateActuelle = dayjs();
  const dateActuelleFormatee = format(dateActuelle.toDate(), "dd/MM/yyyy");
  const [dateRetrait, setDateRetrait] = useState(dayjs());
  const [heureRetrait, setHeureRetrait] = useState();
  const [bureauId, setBureauId] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [reservation, setReservation] = useState({
    user_id: user?.user?.id,
    nomFamille: user?.user?.name,
    email: user?.user?.email,
    montantToExchange: state.montantToExchane,
    MontantToReceive: state.MontantToReceive,
    typeOperation: state.typeOperation,
    devise: state.cour.devise.name,
    devise_id: state.cour.devise_id,
    cour_id: state.cour.id,
    taux:
      state.typeOperation === "achat"
        ? state.cour.prixAchat
        : state.cour.prixVente,
    dateRetrait: dateRetrait,
    heureRetrait: heureRetrait,
    telephone: "",
  });

  useEffect(() => {
  setReservation((prev) => ({
    ...prev,
    user_id: user?.user?.id,
    nomFamille: user?.user?.name,
    email: user?.user?.email,
    montantToExchange: state.montantToExchane,
    MontantToReceive: state.MontantToReceive,
    typeOperation: state.typeOperation,
    devise: state.cour.devise.name,
    devise_id: state.cour.devise_id,
    cour_id: state.cour.id,
    taux:
      state.typeOperation === "achat"
        ? state.cour.prixAchat
        : state.cour.prixVente,
    dateRetrait: dateRetrait,
    heureRetrait: heureRetrait,
  }));
}, [user]);

  useEffect(() => {
    setReservation((prev) => ({
      ...prev,
      dateRetrait: dateRetrait,
    }));
  }, [dateRetrait]);

  useEffect(() => {
    setIsButtonEnabled(isChecked);
  }, [isChecked]);

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };

  const handleClick = () => {
    if (!user.user) {
      console.error("User is not defined");
      return;
    }

    setLoading(true);
    addReservation(reservation)
      .then((data) => {
        if (data && data.data && data.data.id) {
          navigate(`/reservation/confirmation/${data.data.id}`);
        } else {
          // console.error("Erreur : les données de réservation sont manquantes");
          alert(
            "Le serveur est momentanément indisponible. Veuillez réessayer plus tard. Merci pour votre patience",
            data.data.id
          );
        }
      })
      .catch((error) => {
        // console.error("Erreur lors de l'ajout de la réservation :", error);
        alert(
          "Le serveur est momentanément indisponible. Veuillez réessayer plus tard. Merci pour votre patience"
        );
      })
      .finally(() => {
        setLoading(false); // Set loading to false after API call
      });
  };

  const handleChangeHeure = (event) => {
    setReservation((s) => ({ ...s, heureRetrait: event.target.value }));
  };
  // Fonction pour comparer les heures passées
  const estPasse = (heurePlage) => {
    const [debut, fin] = heurePlage.split(" - ");
    const maintenant = dayjs();
    return maintenant.isAfter(
      dayjs(`${dateRetrait.format("YYYY-MM-DD")} ${fin}`)
    );
  };

  // Liste des plages horaires
  const heuresDisponibles = [
    "08:00 - 10:00",
    "10:00 - 12:00",
    "12:00 - 14:00",
    "14:00 - 16:00",
    "16:00 - 18:00",
    "18:00 - 20:00",
    "22:00 - 23:59",
  ];

  return (
    <Stack direction="column" spacing={2}>
      {loading ? (
        <Loader />
      ) : (
        <Box
          sx={{
            backgroundColor: "white",
            borderRadius: 2,
            border: "solid 1px goldenrod",
          }}
        >
          <Box
            sx={{
              backgroundColor: "goldenrod",
              borderRadius: "8px 8px 0 0",
              pl: 2,
              // textAlign: "center",
            }}
          >
            <Typography variant="h5">
              {user ? "Bienvenue" : "Se connecter"}
            </Typography>
          </Box>
          <Box sx={{ padding: 2 }}>
            {user ? (
              <Box>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      disabled
                      label="Code client"
                      id="codeclient"
                      name="codeclient"
                      size="small"
                      value={user.user.id}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      disabled
                      label="Nom du client"
                      id="nomClient"
                      name="nomClient"
                      size="small"
                      value={user?.user?.name}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      disabled
                      label="Email"
                      id="email"
                      name="email"
                      size="small"
                      value={user?.user?.email}
                    />
                  </Grid>
                </Grid>

                <Grid container spacing={2} sx={{ mt: 1 }}>
                  <Grid item xs={12} sm={6}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        label="Date de retrait"
                        value={dateRetrait}
                        onChange={(date) => setDateRetrait(dayjs(date))}
                        minDate={dateActuelle}
                        slotProps={{
                          textField: { fullWidth: true, size: "small" },
                        }}
                      />
                    </LocalizationProvider>
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <FormControl
                      fullWidth
                      size="small"
                      // required
                      // error={!heureRetrait}
                    >
                      <InputLabel id="heure-label">Heure de retrait</InputLabel>
                      <Select
                        label="Heure de retrait"
                        labelId="heure-label"
                        id="heure-select"
                        onChange={handleChangeHeure}
                        value={heureRetrait}
                      >
                        {(dateRetrait.isSame(dateActuelle, "day")
                          ? heuresDisponibles.filter((h) => !estPasse(h))
                          : heuresDisponibles
                        ).map((heure) => (
                          <MenuItem key={heure} value={heure}>
                            {heure}
                          </MenuItem>
                        ))}
                      </Select>
                      {/* {!heureRetrait && (
                        <Typography color="error" variant="caption">
                          Ce champ est requis
                        </Typography>
                      )} */}
                    </FormControl>
                  </Grid>
                </Grid>

                {bureauId && (
                  <Grid item xs={12}>
                    <Box>{<Bureau id={bureauId} />}</Box>
                  </Grid>
                )}

                {/* <Conditions /> */}
                <Stack direction={"row"} spacing={2} justifyContent={"left"}>
                  <Checkbox
                    label=""
                    color="primary"
                    checked={isChecked}
                    onChange={handleCheckboxChange}
                  />
                  <Typography
                    paragraph="true"
                    sx={{ padding: "16px 0", m: 0 }}
                    color="secondary"
                  >
                    J'ai lu et j'accepte
                    <Link
                      color="inherit"
                      href="/conditions"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      La politique de confidentialité et les conditions
                      générales d'utilisation du site
                    </Link>
                  </Typography>
                </Stack>
                <Button
                  variant="contained"
                  type="submit"
                  disabled={!isButtonEnabled}
                  onClick={handleClick}
                >
                  Passer ma reservation
                </Button>
                {state.typeOperation !== "achat" && (
                  <Typography variant="body2">
                    Merci de présenter vos documents d'identité au moment du
                    retrait
                  </Typography>
                )}
              </Box>
            ) : (
              <Login connection="reservation" />
            )}
          </Box>
        </Box>
      )}
    </Stack>
  );
}

export default ClientAuth;
